import React from "react";
import "../Stylesheets/NotFound.css";

export default function NotFound() {
    return (
        <div className="NotFound">
            <h3>La página que estás buscando no existe!</h3>
        </div>
    );
};